"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTimeRange = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
exports.SessionTimeRange = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n\n    display: flex;\n    align-items: center;\n    padding: 0.4rem 0.8rem;\n    color: ", ";\n    background-color: ", ";\n    border-radius: 10rem;\n\n    svg {\n      margin-right: 0.4rem;\n    }\n  "], ["\n    ", ";\n\n    display: flex;\n    align-items: center;\n    padding: 0.4rem 0.8rem;\n    color: ", ";\n    background-color: ", ";\n    border-radius: 10rem;\n\n    svg {\n      margin-right: 0.4rem;\n    }\n  "])), theme.fonts.medium13, theme.colors.brand500, theme.colors.brand100);
});
var templateObject_1, templateObject_2;
